module.exports = __webpack_public_path__ + "img/pocket-mobile_cn.3931369.jpg";